import React from 'react';

export const StakeholderBlueIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M14.9631 14.2268C15.6897 14.2268 16.2787 14.8202 16.2787 15.5523V16.0937C16.2787 16.4317 16.1739 16.7612 15.9788 17.0361C15.0745 18.3112 13.5977 18.9429 11.5968 18.9429C9.59545 18.9429 8.11947 18.311 7.21728 17.0352C7.02307 16.7606 6.9187 16.4318 6.9187 16.0946V15.5523C6.9187 14.8202 7.50773 14.2268 8.23433 14.2268H14.9631ZM11.5968 7.15625C13.2123 7.15625 14.5219 8.47576 14.5219 10.1034C14.5219 11.7311 13.2123 13.0507 11.5968 13.0507C9.98129 13.0507 8.67169 11.7311 8.67169 10.1034C8.67169 8.47576 9.98129 7.15625 11.5968 7.15625Z"
      fill="#27B0E0"
    />
    <circle cx="11.6" cy="12" r="6.8" stroke="#27B0E0" strokeWidth="0.8" />
    <circle cx="11.6" cy="12" r="9.2" stroke="#27B0E0" strokeWidth="0.8" />
    <circle cx="21.2" cy="12" r="1.6" fill="#27B0E0" />
    <circle cx="2.00002" cy="12" r="1.6" fill="#27B0E0" />
    <circle cx="6.79995" cy="3.59375" r="1.6" fill="#27B0E0" />
    <circle cx="16.7406" cy="3.59375" r="1.6" fill="#27B0E0" />
    <circle cx="6.79995" cy="20.3062" r="1.6" fill="#27B0E0" />
    <circle cx="16.7406" cy="20.3062" r="1.6" fill="#27B0E0" />
  </svg>
);
